//根据不同的环境更改不同的baseUrl
let baseUrl = '';
if (process.env.NODE_ENV == 'development') { // 测试环境
    //baseUrl = 'http://192.168.10.183/api'
    baseUrl = 'https://zhxzbg.kuruankeji.cn/api';
} else if (process.env.NODE_ENV == 'production') { //  线上环境
    baseUrl = 'https://zhxzbg.kuruankeji.cn/api';
}

export {
    baseUrl, //导出baseUrl
}